const binding = { modules: {}, dataActions: {} };

    (binding.modules['bayerscustomtheme'] = {
        c: () => require('partner/themes/bayerscustomtheme/bayerscustomtheme.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['buybox','checkout-shipping-address','checkout','content-block','media-gallery','navigation-menu','order-confirmation','promo-banner','search-result-container','text-block'],
        iNM: false,
        ns: '__local__',
        n: 'bayerscustomtheme',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'bayerscustomtheme.theme.settings.json',
        md: 'src/themes/bayerscustomtheme'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };